import { useEffect, useState, forwardRef } from 'react';
import Container from "@mui/material/Container";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Paper,
    Snackbar,
    Stack,
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';

import CCSelect from '../dataEntry/CCSelect';
import GameModeSelect from '../dataEntry/GameModeSelect';
import MapSelect from '../dataEntry/MapSelect';
import RaceEntryPlayer from '../dataEntry/RaceEntryPlayer';
import Header from "../headers/Header";
import SubmitButton from '../buttons/SubmitButton';
import { validateFullRaceInput } from '../utils/InputValidation';
import { submitRace } from '../utils/RaceSubmission';
import LoadingShells from '../utilComponents/LoadingShells';
import { useRoster } from '../utils/useRoster';



const Constants = require("../constants/Constants");
let IMAGE_URL = Constants.IMAGE_URL
let CCLIST = Constants.CCLIST
let CHARACTERS = Constants.CHARACTERS

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const RaceEntry = () => {

    const alertInit = {
        "show": false,
        "messages": []
    }

    const raceInit = {
        "id": 0,
        "name": "select",
        "url": `${IMAGE_URL}map_names/SelectMap.png`,

    }

    const ccInit = {
        "id": 0,
        "name": "select",
        "url": `${IMAGE_URL}cc_icons/SelectCC.png`,
    }

    const gameModeInit = {
        "id": -1,
        "name": "select",
        "url": `${IMAGE_URL}game_modes/SelectMode.png`,
    }

    const mapImageInit = `${IMAGE_URL}maps/NoMapSelected.png`

    // Sorts CC list to display in drop down
    CCLIST.ccs.sort((a, b) => (a.id > b.id) ? 1 : -1)

    // ------ Variables / Set Functions ------

    // Setting Init Roster
    const { roster } = useRoster();

    const [alert, setAlert] = useState(alertInit)
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false)

    // Init Variables/Set Fuctions for Players 1-4
    const [players, setPlayers] = useState([1, 2])

    const [playerData, setPlayerData] = useState(() =>
        players.map(() => ({
            playerId: null,
            characterId: null,
            place: null,
        }))
    );

    // Update a specific player's data using the index
    const updatePlayerData = (index, field, value) => {
        setPlayerData((prevData) =>
            prevData.map((data, i) =>
                i === index ? { ...data, [field]: value } : data
            )
        );
    };

    console.log(playerData)
    // Init Variable/Set Fuction for Map and CC toggle buttons 
    const [showCourses, setShowCourses] = useState(false);
    const [showCC, setShowCC] = useState(false);
    const [showGameMode, setShowGameMode] = useState(false);

    // Init Variable / Set Function for Map Image
    const [mapImage, setMapImage] = useState(mapImageInit);

    const [gameMode, setGameMode] = useState(gameModeInit)

    // Init Variable / Set Function for CC Data needed to display choice and submission to API
    const [ccData, setCCData] = useState(ccInit);

    // Init Variable / Set Function for Race Data needed to display choice and submission to API
    const [raceData, setRaceData] = useState(raceInit);

    // ------ Handlers ------

    // Handler for closing Data Entry Error Alert Dialog
    const handleAlertClose = () => {
        setAlert(alertInit);
    };

    // Handler for Successful Race Submission
    const handleSuccessClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setShowSuccess(false);
    };

    // Automatically close the success banner after 5 seconds
    useEffect(() => {
        if (showSuccess) {
            const timer = setTimeout(() => {
                setShowSuccess(false);
            }, 5000); // 5 seconds

            // Cleanup the timer if the component unmounts or success state changes
            return () => clearTimeout(timer);
        }
    }, [showSuccess]);


    // Handler for CC Choice from drop down
    const handleCC = (e) => {
        e.preventDefault();
        setCCData(
            {
                "id": e.target.getAttribute('value'),
                "name": e.target.getAttribute('name'),
                "url": e.target.getAttribute('src'),
            }
        );
        toggleCC()
    };

    // Handler for Race Choice from drop down
    const handleRace = (e) => {
        e.preventDefault();
        setRaceData(
            {
                "id": e.target.getAttribute('value'),
                "name": e.target.getAttribute('name'),
                "url": e.target.getAttribute('src'),
            }
        );
        setMapImage(`${IMAGE_URL}${e.target.getAttribute('mapImage')}`)
        toggleCourses()

    };

    // Handler for Game Mode Choice from drop down
    const handleGameMode = (e) => {
        e.preventDefault();
        console.log(e.target.getAttribute('value'));
        setGameMode(
            {
                "id": e.target.getAttribute('value'),
                "name": e.target.getAttribute('name'),
                "url": e.target.getAttribute('src'),
            }
        );
        toggleGameMode();
    };

    // Adding Player to List
    const addPlayer = () => {
        if (players.length < 4) {
            setPlayers((prevPlayers) => {
                const newPlayers = [...prevPlayers, prevPlayers.length + 1];
                setPlayerData((prevData) => [
                    ...prevData,
                    { playerId: null, characterId: null, place: null },
                ]);
                return newPlayers;
            });
        }
    };

    // Removing a Player from the List
    const removePlayer = () => {
        if (players.length > 2) {
            setPlayers((prevPlayers) => {
                const newPlayers = prevPlayers.slice(0, -1);
                setPlayerData((prevData) => prevData.slice(0, -1));
                return newPlayers;
            });
        }
    };

    // Handler for CC List Toggle
    const toggleCC = (e) => {
        e?.preventDefault();
        setShowCC((showCC) => !showCC);
        console.log(showCC)
    };

    // Handler for Course List Toggle
    const toggleCourses = (e) => {
        e?.preventDefault();
        setShowCourses((showCourses) => !showCourses);
    };

    // Handler for CC List Toggle
    const toggleGameMode = (e) => {
        e?.preventDefault();
        setShowGameMode((showGameMode) => !showGameMode);
    };

    // Handler for Form Submisson to Race Entry API Endpoint
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        let raceEntryData = {
            engineClassId: String(ccData.id),
            courseId: String(raceData.id),
            grandPrixId: String(gameMode.id),
            usernameId: localStorage.getItem('userId'),
            racePlayers: playerData,
        };

        console.log("Race Entry Data:", raceEntryData);

        let validateData = validateFullRaceInput(raceEntryData);
        console.log("Validation Result:", validateData);

        if (!validateData.valid) {
            console.log("Validation Messages:", validateData.messages);
            setAlert({ show: true, messages: validateData.messages });
            setLoading(false);
            return;
        }

        try {
            console.log("Submitting race data to API...");
            const response = await submitRace(raceEntryData);

            if (response.status === 201) {
                console.log("API Submission Successful!", response.data);
                setShowSuccess(true);
                setRaceData(raceInit)
                setCCData(ccInit)
                setMapImage(mapImageInit)
                setLoading(false);

            } else {
                console.log("API Submission Failed:", response);
                setAlert({ show: true, messages: ["Failed to submit race. Please try again."] });
                setLoading(false);
            }
        } catch (error) {
            console.error("Error submitting race:", error);
            setAlert({ show: true, messages: ["An error occurred while submitting the race. Please try again."] });
            setLoading(false);
        }
    };



    return (

        <Container
            component="main"
            sx={{
                marginTop: 4,
                flexDirection: "column",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}>
            {loading ? (
                <LoadingShells />
            ) : (<>
                <Snackbar open={showSuccess} autoHideDuration={6000} onClose={handleSuccessClose}>
                    <Alert onClose={handleSuccessClose} severity="success" sx={{ width: '100%' }}>
                        Race Submission Successful!
                    </Alert>
                </Snackbar>
                <Dialog
                    open={alert.show}
                    // onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Data Entry Errors"}
                    </DialogTitle>
                    <DialogContent>
                        {alert.messages?.map((message, index) =>
                            <DialogContentText key={`error-message-${index}`} id={`error-message-${index}`}>
                                {index + 1}. {message}
                            </DialogContentText>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleAlertClose} autoFocus>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ p: 1, mb: 3 }}>
                    <Header src={`${IMAGE_URL}headers/RaceEntry.png`} alt="Race Entry Title" />
                </Box>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                        p: 1,
                        bgcolor: 'primary.light',
                        borderRadius: 2,
                        border: 3,
                        width: '200px',
                        boxShadow: 6
                    }}
                >

                    <img
                        loading="lazy"
                        src={`${mapImage}`}
                        style={{ minWidth: "200px", width: "70%" }}
                        alt="Chosen Map"
                    />
                </Box>

                <Box sx={{ p: 1 }}></Box>

                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1, width: { xs: '100%', md: '80%' } }} id="RaceEntryForm">
                    <MapSelect
                        showCourses={showCourses}
                        handleRace={handleRace}
                        raceData={raceData}
                        toggleCourses={toggleCourses}
                    />
                    <CCSelect
                        showCC={showCC}
                        handleCC={handleCC}
                        ccData={ccData}
                        toggleCC={toggleCC}
                    />
                    <GameModeSelect
                        showGameMode={showGameMode}
                        handleGameMode={handleGameMode}
                        gameMode={gameMode}
                        toggleGameMode={toggleGameMode}
                    />
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ p: 1, mt: 1 }}>
                        <Paper elevation={3} sx={{ backgroundColor: "primary.light", border: 2, boxShadow: 6, borderColor: "black" }}>
                            <Stack direction="row">
                                <IconButton aria-label="addicon" sx={{ color: "primary.dark" }} onClick={addPlayer}>
                                    <PersonAddAlt1Icon />
                                </IconButton>
                                <Divider orientation="vertical" variant="middle" flexItem style={{ background: "black" }} />
                                <IconButton aria-label="removeicon" sx={{ color: "primary.dark" }} onClick={removePlayer}>
                                    <PersonRemoveIcon />
                                </IconButton>
                            </Stack>
                        </Paper>
                    </Box>

                    <Box sx={{ p: 2, mt: 1, fontWeight: 'bold' }} >
                        <Grid container spacing={3}>
                            {players?.map((player, index) => (
                                <Grid container item spacing={1} key={`grid-player-${player}`} >
                                    <RaceEntryPlayer
                                        id={index}
                                        roster={roster}
                                        characters={CHARACTERS}
                                        numberOfPlayers={players.length}
                                        onSubmit={handleSubmit}
                                        onUpdate={updatePlayerData}
                                    />
                                    {index < players.length - 1 && (
                                        <Divider
                                            sx={{
                                                width: '95%',
                                                borderBottomWidth: 5,
                                                borderColor: 'black',
                                                mt: 2.5,
                                                mx: 'auto',
                                                ml: { xs: 1.5, sm: 3, md: 4 }
                                            }}
                                        />
                                    )}
                                </Grid>
                            ))}
                        </Grid>
                    </Box>


                    <SubmitButton />
                </Box>
            </>)}
        </Container>
    );
};

export default RaceEntry;
